import { combineReducers } from "redux";
import user from '../Redux/Authenticate/reducer'
import userDetail from "../Redux/GeneralDetails/reducer"
import notificationReducer from "@Components/NewUI/User/actionsNotification";
import dashboardReducer from "./Dashboard/reducer";

const appReducer = combineReducers({
  user,
  userDetail,
  hasReadNotification: notificationReducer,
  dashboard: dashboardReducer,
});


export default appReducer;



